import moment from 'moment';
import store from 'store';
import { settingsSelector } from 'components/_selectors/authSelectors';

export const getCurrentDateTime = () => {
  return moment();
}
export const getFormattedDate = (date, dateFormat="") => {
  // if(settingsSelector(store.getState()).date_format_web){
  //   dateFormat = settingsSelector(store.getState()).date_format_web;
  //   dateFormat = dateFormat.split(" ")[0];
  // }
  if(dateFormat==""){
    dateFormat='DD/MM/YYYY'
  }
  return moment(date).format(dateFormat);
}
export const getFormattedTime = (dateTime, timeFormat='h:mm A') => {
  //  var date = moment().format('YYYY-MM-DD')+" "+time;
  return moment(dateTime).format(timeFormat);
}
export const getFormattedDateTime = (date, dateTimeFormat="") => {
  if(dateTimeFormat==""){
    dateTimeFormat='DD/MM/YYYY h:mm A'
  }
  return moment(date).format(dateTimeFormat);
}
export const getServerFormattedDate = (date) => {
  var dateFormat = "YYYY-MM-DD";
  return moment(date).format(dateFormat);
};